// The screen-space pixel width each point cloud point is drawn at
export const DEFAULT_POINT_SIZE = 2;
export const SMALLEST_POINT_SIZE = 1;
export const LARGEST_POINT_SIZE = 12;
export const POINT_SIZE_STEP = 0.1;
